import { PatientReportEndpoint } from '../../constants/api.config'
import getCharts from '../getCharts'

export default async function PatientReportCRUD(mode, patientID = '-1', id = "-1", type = "-1", data = "-1", newDate = "-1",) {
    try {
        const payload = { mode, patientID, id, type, data, newDate }
        const res = await getCharts(PatientReportEndpoint, payload)
        return res.data
    } catch (error) {
        return error
    }
}